<template>
  <div id="app">
    <navigation>
      <router-view />
    </navigation>
  </div>
</template>

<script>
import { onMounted } from "@vue/composition-api";

export default {
  name: "app",
  mounted() {
    const script = document.createElement("script");
    script.src =
      "https://v1.cnzz.com/z_stat.php?id=1279558686&web_id=1279558686";
    script.language = "JavaScript";
    document.body.appendChild(script);

    //再之后就是在每个页面的方法执行后写上
    //     window._czc.push(['_trackEvent', '点击', '该事件执行的内容']);
  },
  watch: {
    $route() {
      if (window._czc) {
        let location = window.location;
        let contentUrl = location.pathname + location.hash;
        let refererUrl = "/";
        window._czc.push(["_trackPageview", contentUrl, refererUrl]);
      }
    }
  },
  setup() {
    onMounted(() => {
      document.body.addEventListener("focusout", () => {
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
      });
      function isScroller(el) {
        // 判断元素是否为 scroller
        return el.id === "vux_view_box_body";
      }

      document.addEventListener(
        "touchmove",
        function(ev) {
          let target = ev.target;

          // 在 scroller 上滑动，阻止事件冒泡，启用浏览器默认行为。
          if (isScroller(target)) {
            // console.log(target)
            ev.stopPropagation();
          }
        },
        false
      );
    });
  }
};
</script>

<style lang="less">
@import "~vux/src/styles/reset.less";
@import "~vux/src/styles/1px.less";
@import "~vux/src/styles/close.less";

html,
body {
  height: 100%;
  width: 100%;
  overflow-x: hidden;
}

body {
  background-color: #f6f6f6;
}

#app {
  height: 100%;
  /*background: #fff;*/
}

* {
  -webkit-overflow-scrolling: touch;
}
</style>
